<template>
  <div>
    <div class="header-wrap">
      <!-- <img src="@/assets/images/public/commovement-banner.png" alt="" /> -->
      <span class="tit">发现不一样的支付</span>
    </div>
    <div class="nav-segment">
      <div class="nav-wrapper">
        <i class="vertical-line"></i>
        <router-link :to="{ name: 'About1' }" class="about-nav active-nav"
          >企业公告<i></i
        ></router-link>
        <div class="nav-margin">
          <router-link :to="{ name: 'Conact1' }" class="about-nav active-nav"
            >新闻动态<i></i
          ></router-link>
        </div>
        <div class="nav-margin">
          <router-link :to="{ name: 'problem1' }" class="about-nav active-nav"
            >常见问题<i></i
          ></router-link>
        </div>
        <div class="nav-margin">
          <router-link :to="{ name: 'knowledge1' }" class="about-nav active-nav"
            >知识拓展<i></i
          ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowAbout: false,
    }
  },
  methods: {
    aboutUs() {},
  },
}
</script>

<style lang="less" scoped>
.header-wrap {
  background: url('../../assets/images/public/commovement-banner.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 640px;
  display: inline-block;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  .tit {
    font-size: 44px;
    font-family: Alibaba PuHuiTi 2;
    font-weight: normal;
    line-height: 46px;
    color: #ffffff;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
  }
}

.nav-segment {
  width: 100%;
  margin-top: 80px;
  margin-bottom: 110px;
  .nav-wrapper {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .nav-margin {
      margin-top: 46px;
    }
    .about-nav {
      position: relative;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      line-height: 19px;
      color: #000000;
      font-family: PingFang SC;
    }
    .active-nav.router-link-active {
      color: #1677ff;
      i {
        position: absolute;
        top: 2px;
        right: -20px;
        width: 2px;
        height: 20px;
        background-color: #1677ff;
      }
    }
    .vertical-line {
      position: absolute;
      top: -2px;
      left: 82px;
      width: 2px;
      height: 220px;
      background-color: #e8e8e8;
    }
  }
}
</style>
